import { ReactElement } from 'react'
import { Divider, Typography } from '@mui/material'

interface Props {
  title: string
}

/** Titled divider above a group of load display settings. */
const LoadRenderSectionDivider = ({ title }: Props): ReactElement => (
  <Divider textAlign="left">
    <Typography variant="caption" color="text.secondary">
      {title}
    </Typography>
  </Divider>
)

export default LoadRenderSectionDivider
